import React from "react"
import { view } from "react-easy-state"
import { Route, Redirect } from "react-router-dom"
import * as AuthHelper from "helpers/auth.helper"
import { message } from "antd"

const redirectToLogin = ({ loginRoute, location }) => {
  AuthHelper.setToken("")
  AuthHelper.setUserType("")
  message.destroy()
  message.info("You must be logged in to do that")
  return (
    <Redirect
      to={{
        pathname: loginRoute,
        state: { from: location },
      }}
    />
  )
}

const PrivateRoute = ({
  component: Component,
  loginRoute = "/login",
  extraProps,
  ...rest
}) => {
  const renderer = ({ props, loggedIn, userType }) => {
    if (!loggedIn || !["student", "teacher"].includes(userType)) {
      return redirectToLogin({ loginRoute, location: props.location })
    }

    console.log(
      "props, loggedIn, userType",
      `${props}, ${loggedIn}, ${userType}`
    )

    const newProps = {
      ...props,
      ...(extraProps || {}),
    }

    const path = newProps.match.path

    if (userType === "teacher" && path.startsWith("/teachers/")) {
      return <Component {...newProps} />
    }
    if (userType === "student" && !path.startsWith("/teachers/")) {
      return <Component {...newProps} />
    }

    return redirectToLogin({ loginRoute, location: props.location })
  }

  const loggedIn = AuthHelper.isLoggedIn()

  const userType = AuthHelper.getUserType()

  return (
    <Route
      {...rest}
      render={(props) => renderer({ props, loggedIn, userType })}
    />
  )
}

export default view(PrivateRoute)
